import React from 'react';
import { Image, View, Text, TouchableOpacity } from 'react-native';
import { MaterialIcons } from "@expo/vector-icons";

import HeaderDefault from '../../components/HeaderDefault';

import styles from './styles';

const PaymentMethodSell = ({ navigation }) => {
    return (
        <>
            <HeaderDefault title={"Escolha a forma"} />

            <View style={styles.content}>
                <View style={styles.contentList}>
                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate({ name: "SearchUsers", params: { "page":"ConfirmSearchUserSell" } })}>
                        <Image style={[styles.iconInfo, { width: 28, height: 20 }]} source={require('../../../assets/imgs/search.png')} />
                        <View>
                            <Text style={styles.titleItemList}>Buscar</Text>
                            <Text style={[styles.descriptionItemList, { width: 280 }]}>Venda seus tokens para usuários da plataforma e contatos.</Text>
                        </View>
                        <MaterialIcons
                            name="keyboard-arrow-right"
                            size={25}
                            color="#2C2C2E"
                            style={{ alignSelf: 'center' }}
                        />
                    </TouchableOpacity>
                    <View style={styles.hr} />

                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate("Exchange")}>
                        <Image style={[styles.iconInfo, { width: 25, height: 25 }]} source={require('../../../assets/imgs/exchange.png')} />
                        <View>
                            <Text style={styles.titleItemList}>Exchange</Text>
                            <Text style={[styles.descriptionItemList, { width: 280 }]}>Negocie seus tokens através de ordens de venda na plataforma.</Text>
                        </View>
                        <MaterialIcons
                            name="keyboard-arrow-right"
                            size={25}
                            color="#2C2C2E"
                            style={{ alignSelf: 'center' }}
                        />
                    </TouchableOpacity>
                    <View style={styles.hr} />

                    <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate("MarketplaceCategories")}>
                        <Image style={[styles.iconInfo, { width: 25, height: 25 }]} source={require('../../../assets/imgs/platform.png')} />
                        <View>
                            <Text style={styles.titleItemList}>Para a plataforma</Text>
                            <Text style={[styles.descriptionItemList, { width: 280 }]}>Venda seus tokens diretamente no marketplace.</Text>
                        </View>
                        <MaterialIcons
                            name="keyboard-arrow-right"
                            size={25}
                            color="#2C2C2E"
                            style={{ alignSelf: 'center' }}
                        />
                    </TouchableOpacity>
                    <View style={styles.hr} />
                </View>
            </View>
        </>
    );
}

export default PaymentMethodSell;